export const ROLES_LIST_KEY = 'ROLES_LIST_KEY';
export const PERMISSIONS_LIST_KEY = 'PERMISSIONS_LIST_KEY';
export const ROLES_ONE_KEY = 'ROLES_ONE_KEY';
export const ROLES_PROVIDER_ONE_KEY = 'ROLES_PROVIDER_ONE_KEY';
export const ROLES_PROVIDERS_LIST_KEY = 'ROLES_PROVIDERS_LIST_KEY';
export const ROLES_PROVIDERS_USERS_LIST_KEY = 'ROLES_PROVIDERS_USERS_LIST_KEY';
